import React from "react";
import "./separator.scss";

const Separator = () => {
  const compClass = "cfm-separator";
  return <hr className={compClass} />;
};

export default Separator;
